import React from 'react'
import { useSelector } from 'react-redux'
import { Dropdown } from 'semantic-ui-react'
import { IRootReducerState } from 'state/reducers'

const ExternalApplicationStatistics: React.FC = () => {
  const token = useSelector((state: IRootReducerState) => state.auth.tokens.IdToken)
  const url = useSelector((state: IRootReducerState) => state.region.selectedRegion)

  const formatURL = (application: string) => {
    let baseURL = url

    if (url === 'localhost') {
      baseURL = 'localhost.carsys.online'
    }

    return `https://gms-api.${baseURL}/support/external-application-stats/${application}/index?Authorization=${token}`
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Dropdown item button text='select external application'>
        <Dropdown.Menu>
          <Dropdown.Item target='blank' href={formatURL('fifm')}>
            Go to fifm
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default ExternalApplicationStatistics
